/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function AIReplaceSelection({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g clipPath="url(#AIReplaceSelection_svg__a)"><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="M9.134 10.5c0-.791-.238-1.564-.685-2.222a4.05 4.05 0 0 0-1.825-1.474 4.13 4.13 0 0 0-2.35-.227A4.1 4.1 0 0 0 2.19 7.672 4 4 0 0 0 1.078 9.72a3.94 3.94 0 0 0 .232 2.31c.307.732.829 1.356 1.498 1.796.668.44 1.455.674 2.26.674" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="M11 9.237 9.547 11.71l-2.516-1.428" /><path fill="currentColor" fillRule="evenodd" d="M14.181 3.5a1.4 1.4 0 0 0-1.4-1.4h-1.184a.6.6 0 1 1 0-1.2h1.184a2.6 2.6 0 0 1 2.6 2.6v1.184a.6.6 0 1 1-1.2 0zm.6 3.426a.6.6 0 0 1 .6.6v1.895a.6.6 0 1 1-1.2 0V7.526a.6.6 0 0 1 .6-.6m0 3.79a.6.6 0 0 1 .6.6V12.5a2.6 2.6 0 0 1-2.6 2.6h-1.184a.6.6 0 1 1 0-1.2h1.184a1.4 1.4 0 0 0 1.4-1.4v-1.184a.6.6 0 0 1 .6-.6M10.302 1.5a.6.6 0 0 1-.6.6H7.808a.6.6 0 0 1 0-1.2h1.894a.6.6 0 0 1 .6.6m-.947 13a.6.6 0 0 1-.6.6H4.86a.6.6 0 1 1 0-1.2h3.895a.6.6 0 0 1 .6.6m-3.79-13a.6.6 0 0 1-.6.6H3.781a1.4 1.4 0 0 0-1.4 1.4v1.184a.6.6 0 1 1-1.2 0V3.5a2.6 2.6 0 0 1 2.6-2.6h1.184a.6.6 0 0 1 .6.6" clipRule="evenodd" /></g><defs><clipPath id="AIReplaceSelection_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;